import React from 'react';
import styles from './dots.css';
import cx from 'classnames';
import T from 'prop-types';

const defaultButtonStyles = disabled => ({
  border: 0,
  background: 'rgba(0,0,0,0.4)',
  color: 'white',
  padding: 10,
  outline: 0,
  opacity: disabled ? 0.3 : 1,
  cursor: disabled ? 'not-allowed' : 'pointer',
});

export class PreviousButton extends React.Component {
  constructor() {
    super(...arguments);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event) {
    event.preventDefault();
    this.props.previousSlide();
  }
  render() {
    const disabled =
      (this.props.currentSlide === 0 && !this.props.wrapAround) ||
      this.props.slideCount === 0;
    return (
      <button
        style={defaultButtonStyles(disabled)}
        disabled={disabled}
        onClick={this.handleClick}
      >
        PREV
      </button>
    );
  }
}

export class NextButton extends React.Component {
  constructor() {
    super(...arguments);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event) {
    event.preventDefault();
    this.props.nextSlide();
  }
  render() {
    const disabled =
      this.props.currentSlide + this.props.slidesToScroll >=
        this.props.slideCount && !this.props.wrapAround;
    return (
      <button
        style={defaultButtonStyles(disabled)}
        disabled={disabled}
        onClick={this.handleClick}
      >
        NEXT
      </button>
    );
  }
}

const Dot = ({
  color, active, index, noTransition, onClick,
}) => (
  <div
    onClick={onClick}
    style={{
      borderColor: color,
    }}
    className={cx(
      active ? styles.dotActive : styles.dot,
      noTransition && styles.noTransition,
    )}
  >
    <span className={styles.hidden}>{`Слайд номер ${index + 1}`}</span>
  </div>
);

Dot.defaultProps = {
  noTransition: false,
};

Dot.propTypes = {
  color: T.string.isRequired,
  active: T.bool.isRequired,
  index: T.number.isRequired,
  noTransition: T.bool,
};

export class PagingDots extends React.Component {
  getIndexes(count, inc) {
    const arr = [];
    for (let i = 0; i < count; i += inc) {
      arr.push(i);
    }
    return arr;
  }

  getListStyles() {
    return {
      position: 'relative',
      margin: 0,
      top: -10,
      padding: 0,
    };
  }

  getListItemStyles() {
    return {
      listStyleType: 'none',
    };
  }

  getButtonStyles(active) {
    return {};
  }

  render() {
    const indexes = this.getIndexes(
      this.props.slideCount,
      this.props.slidesToScroll,
    );
    return (
      <div className={styles.dots}>
        {indexes.map(index => (
          <Dot
            key={index}
            color="#ffffff"
            active={this.props.currentSlide === index}
            index={index}
            onClick={this.props.goToSlide.bind(null, index)}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/Carousel/defaultControls.js